<template>
  <div class="select-title" v-if="HomeHonor">
    <div class="select-info">
      <rl-title :show-name="HomeHonor.name" />
      <div class="info-detail">
          <home-select-item
              :select-item="HomeHonor.childClassify[2]"
              v-if="HomeHonor.childClassify"
          ></home-select-item>
      </div>
    </div>
  </div>
</template>
<script>
import HomeContentItem from "./content/home/Item";
import HomeSelectItem from "@/views/Home/HomeSelectItem";
import RlTitle from "@/components/Title";
export default {
  name: "HomeSelect",
  components: {RlTitle, HomeSelectItem, HomeContentItem},
  props:{
    HomeHonor:{
    }
  },
}
</script>

<style lang="less" scoped>
  .base{
    width: 74.5vw;
    margin: 0 auto;
    text-align: center;
  }
  .select-title:extend(.base){
      padding-bottom:40px ;
      text-align: center;
      .select-info{
        .info-detail{
          display: flex;
          justify-content: space-between;
          padding-bottom: 30px;
        }
      }
      position: relative;
    }

</style>